module.exports = __webpack_public_path__ + "img/leapq-logo.daa21fbf.jpg";